import { ACCB_URL } from "app/constants";

/**
 * TinyMCE API key configuration for ACCB.
 */
export const TINYMCE_STAGE_API_KEY = "nwa0ryprsylfs5g41820nbjwx7a0l0ld3cznaublmf8xn3yo";
export const TINYMCE_PROD_API_KEY = "pf5b8km0rcl0cmbhz7yekf2njschi2th6nkgy0ndv79jk5j7";

/**
 * Determines whether the app is currently running in a production environment.
 */
export const isProductionEnvironment = () => {
  if (typeof window === "undefined") return false;

  const appEnv = String(process.env.REACT_APP_ENV || "").toLowerCase();
  if (appEnv === "staging" || appEnv === "stage" || appEnv === "dev" || appEnv === "development") {
    return false;
  }

  const hostname = String(window.location.hostname || "").toLowerCase();
  const prodHost = String(ACCB_URL || "ack.org.in").toLowerCase();

  return (
    hostname === prodHost ||
    hostname === `www.${prodHost}` ||
    appEnv === "production" ||
    appEnv === "prod"
  );
};

/**
 * Resolves the appropriate TinyMCE API key based on environment.
 * Priority:
 * 1. REACT_APP_TINYMCE_API_KEY (environment variable override if set)
 * 2. TINYMCE_PROD_API_KEY if running in production environment
 * 3. TINYMCE_STAGE_API_KEY for staging, dev, and localhost
 */
export const getTinyMceApiKey = () => {
  if (process.env.REACT_APP_TINYMCE_API_KEY) {
    return process.env.REACT_APP_TINYMCE_API_KEY;
  }
  return isProductionEnvironment()
    ? TINYMCE_PROD_API_KEY
    : TINYMCE_STAGE_API_KEY;
};

export const TINYMCE_API_KEY = getTinyMceApiKey();
